import AutoNumeric from "./AutoNumeric";
import "./index.scss";
const initAutoNumeric = (element) => {
    new AutoNumeric(element);
}

export {
    AutoNumeric,
    initAutoNumeric
}
